import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route changes, except when only the language segment changes
// (e.g. /ec -> /en on the same page).
const stripLang = (pathname) => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return "";
  if (parts[0] === "ec" || parts[0] === "en") {
    return "/" + parts.slice(1).join("/");
  }
  return pathname;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = window.__lastPathnameNoLang;
    const current = stripLang(pathname);
    if (prev !== current) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    window.__lastPathnameNoLang = current;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
